/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Created by MinhQuan on 12/22/2015.
 */

angular.module('common.template.additional-code.popup',['common.filter.description', 'taric.model.additional-code']).controller('AdditionalCodePopupController',
    function(CONSTANTS, $uibModalInstance, $uibModal, additionalCode, simulationDate){
        var  additionalCodePopupCtrl = this;
        additionalCodePopupCtrl.additionalCode = additionalCode;
        additionalCodePopupCtrl.simulationDate = simulationDate;
        additionalCodePopupCtrl.dateFormat = CONSTANTS.dateFormat;
        additionalCodePopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
        
        additionalCodePopupCtrl.openFootnotePopup = function (size, footnoteId){
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, additionalCodePopupCtrl.simulationDate);
                    }
                }
            });
        };
    });



// WEBPACK FOOTER //
// ./app/common/popup/additional-code/additional-code-popup.js